import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { Indicators } from 'entities/ticket/ui/card-of-ticket/ui/components/indicators'
import s from 'entities/ticket/ui/card-of-ticket/ui/styles.module.scss'
import { FlyItem } from 'entities/ticket/ui/direction-detail/types.ts'
import { TransferDetail } from 'entities/ticket/ui/transfer-detail'

import { prepareTimeShow } from 'shared/lib//ticketRender'
import { Border } from 'shared/ui/border'
import { Paper } from 'shared/ui/paper'

import styles from './styles.module.scss'

export enum TYPE_CARD {
  CARD_POINT = 'card_point',
  CARD_TRANSFER = 'card_transfer',
}

export interface AirplaneDetail {
  name?: string
  timeFly?: number
  icon?: string
  onDetail?: () => void
}

export interface ItemArrDep {
  time: string
  date: string
  city: string
  airport?: string
  code?: string
  terminal?: string
}

export interface ItemTransferDuration {
  name?: string
  time?: number
  isNight?: boolean
  baggage_recheck?: boolean
  is_airport_change?: boolean
}

interface RenderText {
  title: string
  subTitle?: string
  size?: number
}

const RenderTextItem = ({ title, subTitle, size = 14 }: RenderText) => {
  return (
    <div className={styles.wrapperTextItem}>
      <p
        className={styles.title}
        style={{ fontSize: size }}
      >
        {title}
      </p>
      {subTitle && <span className={styles.subTitle}>{subTitle}</span>}
    </div>
  )
}

const AirPlane = ({ name, timeFly, icon, onDetail }: AirplaneDetail) => {
  const { t } = useTranslation()

  return (
    <div className={styles.airplane}>
      <div className={styles.left}>
        <img
          src={icon}
          alt=""
        />

        <div className={styles.detail}>
          <p className={styles.title}>{name}</p>
          <span className={styles.time}>
            {t('time_travel', { duration: prepareTimeShow(timeFly) })}
          </span>
        </div>
      </div>

      <div
        className={clsx(styles.button, 'semi-bold-12')}
        onClick={() => onDetail?.()}
      >
        {t('more')}
      </div>
    </div>
  )
}

const FromTo = ({ from, to }: { from: ItemArrDep; to: ItemArrDep }) => {
  return (
    <div className={styles.wrapperFromTo}>
      <div className={styles.left}>
        <span className={clsx(styles.start, styles.point)} />
        <div className={styles.stick} />
        <span className={clsx(styles.end, styles.point)} />
      </div>

      <div className={styles.right}>
        <div className={styles.itemDetail}>
          <div className={styles.time}>
            <RenderTextItem
              title={from.time}
              subTitle={from.date}
              size={16}
            />
          </div>

          <div className={styles.country}>
            <RenderTextItem
              title={from.city}
              subTitle={from.airport}
              size={16}
            />
          </div>
        </div>

        <div className={styles.itemDetail}>
          <div className={styles.time}>
            <RenderTextItem
              title={to.time}
              subTitle={to.date}
              size={16}
            />
          </div>

          <div className={styles.country}>
            <RenderTextItem
              title={to.city}
              subTitle={to.airport}
              size={16}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export interface IDirectionDetail {
  time?: number
  title: string
  isDifficultRoute?: boolean
  timeObject?: {
    hours?: number
    minutes?: number
    common?: number
  }
  flyItems?: FlyItem[]
  onDetail?: (index: number) => void
}

const DirectionDetail = (data: IDirectionDetail) => {
  const { t } = useTranslation()

  const { flyItems, onDetail, title, time } = data

  const firstDep = flyItems?.[0]?.dep?.date

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {title && <p className={styles.title}>{title}</p>}
        {time ? (
          <span className={styles.time}>
            {firstDep} • {t('time_travel', { duration: prepareTimeShow(time) })}
          </span>
        ) : null}
      </div>

      {flyItems?.map((item, index) => (
        <div
          key={'item' + index}
          className={styles.wrapperFromToItem}
        >
          <Paper
            padding={[12, 14]}
            radius="24px"
          >
            <div className={styles.fromToItem}>
              <AirPlane
                {...item.airPlane}
                onDetail={() => onDetail?.(index)}
              />

              <Border />

              {item?.dep && item?.arr && (
                <FromTo
                  from={item.dep}
                  to={item.arr}
                />
              )}
            </div>

            <Border />

            <div className={s.indicatorWrapper}>
              <Indicators baggageInfo={item.baggageInfo} />
            </div>
          </Paper>

          {item.transfer && <TransferDetail {...item.transfer} />}
        </div>
      ))}
    </div>
  )
}

export default DirectionDetail
